// Module
var code = `<div ng-controller="DateRangeCtrl" class="form-group {{form.htmlClass}}" ng-class="{'has-error': hasError()}">
    <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label>

    <div class="{{form.fieldHtmlClass}}">
        <input date-range-picker
               sf-field-model
               class="form-control date-picker"
               ng-init="\$\$value\$\$.timezone_offset = timezone_offset"
               type="text"
               options="{
                    applyClass: 'btn-green',
                    locale: {
                        applyLabel: 'Apply',
                        fromLabel: 'From',
                        format: 'YYYY-MM-DD HH:mm',
                        toLabel: 'To',
                        cancelLabel: 'Cancel',
                        customRangeLabel: 'Custom range'
                    },
                    timePicker: true,
                    timePicker24Hour: true,
                    ranges: ranges,
                    eventHandlers: eventHandlers
                }"
        />
    </div>
    <span class="help-block" sf-message="form.description"></span>
</div>
`;
// Exports
module.exports = code;